module.exports = __webpack_public_path__ + "static/media/arrowUp.26238e1a.svg";